<template>
  <div>
    <div class="popup-wrapper">
      <div class="popup-header">
        <span class="popup-header-text">
          {{ device.title }} - {{ device.description }}
        </span>
      </div>
      <div class="popup-content">
        <table>
          <tr>
            <td>
              <b>Status: </b>
              <span
                class="popup-content-text mobilehide"
                v-if="device.charts"
                >{{ device.parsedData.output }}</span
              >
            </td>
            <td>
              <button
                class="popup-content-charts-btn mobilehide"
                v-if="device.charts"
                @click="popupClicked(device)"
              >
                <i class="fal fa-chart-bar"></i>
              </button>
              <span class="popup-content-text mobilehide" v-else>{{
                device.parsedData.output
              }}</span>
              <span class="popup-content-text desktophide">{{
                device.parsedData.output
              }}</span>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  props: {
    device: Object
  },
  methods: {
    popupClicked(device) {
      this.$bus.emit("buildChartdata", device);
    },
    showChart() {
      this.chartWindowVisible = true;
    }
  }
});
</script>
